import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./src/bus/app-bus.js